import Vue from 'vue';
import Vuex from 'vuex';
import login from '@/modules/login/store';
import auth from '@/store/auth';
import entidade from '@/store/entidade';
import user from '@/store/user';
import carrinho from '@/store/carrinho';
import cotacaoFiltro from '@/store/cotacao-filtro';
import listagemCotacao from '@/store/listagem-cotacao';
import indicadoresFornecedor from '@/store/indicadores-fornecedor';
import matriz from '@/store/matriz';
import compraConjuntaCotacaoPendente from '@/store/compra-conjunta-cotacao-pendente';
import compraConjuntaCotacaoFiltro from '@/store/cotacao-compra-conjunta-filtro';
import listagemFornecedores from '@/store/listagem-fornecedores';
import gestaoFornecedores from '@/store/gestao-fornecedores';
import listagemProdutos from '@/store/listagem-produtos';
import listagemRequisicao from '@/store/listagem-requisicao';
import listagemUnidadesMedida from '@/store/listagem-unidades-medida';
import listagemCompra from '@/store/listagem-compra';
import listagemAprovacao from '@/store/listagem-aprovacao';
import requisicaoGeracao from '@/store/requisicao-geracao';
import listagemTiposUso from '@/store/listagem-tipos-uso';
import listagemGrupos from '@/store/listagem-grupos';
import listagemModosDePagamento from '@/store/listagem-modos-de-pagamento';
import listagemTipoNotaEntrada from '@/store/listagem-tipo-nota-entrada';
import gestaoEntrega from '@/store/gestao-entrega';
import minhaConta from '@/store/minha-conta';
import cadastroProduto from '@/store/cadastro-produto';
import listagemProjetos from '@/store/listagem-projetos';
import listagemCentroCusto from '@/store/listagem-centro-custo';
import listagemMensagens from '@/store/listagem-mensagens';
import painelIntegracao from '@/store/painel-integracao';
import listagemTabelasPreco from '@/store/listagem-tabelas-preco';
import listagemAprovacaoSolicitacao from '@/store/listagem-aprovacao-solicitacao';
import listagemAprovacaoCompra from '@/store/listagem-aprovacao-compra';
import listagemLocaisEntrega from '@/store/listagem-locais-entrega';
import metabaseDashboard from '@/store/metabase-dashboard';
import listagemCotacaoFrete from '@/store/listagem-cotacao-frete';
import listagemContratacaoFrete from '@/store/listagem-contratacao-frete';
import painelNotificacao from '@/store/painel-notificacao';
import listagemNotasFiscais from '@/store/listagem-notas-fiscais';
import listagemFornecedoresGestaoGrupos from '@/store/listagem-fornecedores-gestao-grupos';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    login,
    auth,
    entidade,
    user,
    carrinho,
    cotacaoFiltro,
    listagemCotacao,
    indicadoresFornecedor,
    matriz,
    compraConjuntaCotacaoPendente,
    compraConjuntaCotacaoFiltro,
    listagemFornecedores,
    gestaoFornecedores,
    listagemProdutos,
    listagemRequisicao,
    listagemUnidadesMedida,
    listagemCompra,
    listagemAprovacao,
    requisicaoGeracao,
    listagemModosDePagamento,
    listagemGrupos,
    listagemTiposUso,
    listagemTipoNotaEntrada,
    minhaConta,
    gestaoEntrega,
    cadastroProduto,
    listagemProjetos,
    listagemCentroCusto,
    painelIntegracao,
    listagemMensagens,
    listagemTabelasPreco,
    listagemAprovacaoSolicitacao,
    listagemAprovacaoCompra,
    listagemLocaisEntrega,
    metabaseDashboard,
    listagemCotacaoFrete,
    listagemContratacaoFrete,
    painelNotificacao,
    listagemNotasFiscais,
    listagemFornecedoresGestaoGrupos,
  },
});
